import styled from 'styled-components';

export const Input = styled.input<{ width: string }>`
  width: ${({ width }) => width};
  border: none;
  border-bottom: 1px solid #5c9aff;
  padding: 1rem 0;
  background: transparent;
  color: #fff;
  margin-top: 3.2rem;

  &::placeholder {
    color: #fff;
  }
`;

export const ErrorMessage = styled.span`
  color: #ff0000;
  font-size: 1.2rem;
`;
